import { action, makeObservable, observable } from 'mobx';
import { RoundStatus } from '@pascal/pascal-core';

class ResultsStore {
  lastFiveResults = [];

  topGoals = [];

  constructor() {
    makeObservable(this, {
      lastFiveResults: observable,
      topGoals: observable,
      getLastFiveResult: action.bound,
      getTopGoals: action.bound,
    });
  }

  getLastFiveResult(results) {
    this.lastFiveResults = results
      ?.filter((item) => item.status === RoundStatus.Finished)
      ?.slice(0, 5);
  }

  getTopGoals(topGoal) {
    this.topGoals = topGoal;
  }
}

export const resultStore = new ResultsStore();
